import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Paper } from '@mui/material';
import Api from '../../services/Api.ts';


const UpdateConfig = ({ initialKey = 'driver_config', initialValue = '', initialDescription = '' }) => {
  const [key, setKey] = useState(initialKey);
  const [value, setValue] = useState(initialValue);
  const [description, setDescription] = useState(initialDescription);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [fetching, setFetching] = useState(true);

  const [configId, setConfigId] = useState<string | null>(null);
  React.useEffect(() => {
    setFetching(true);
    Api.get('/driver-config')
      .then((res) => {
        const items = res.data?.data || [];
        const driverConfigItem = items.find((item) => item.key === 'driver_config');
        if (driverConfigItem && driverConfigItem.value) {
          setValue(JSON.stringify(JSON.parse(driverConfigItem.value), null, 2));
          setDescription(driverConfigItem.description || '');
          setConfigId(driverConfigItem.id || driverConfigItem._id || null);
        }
      })
      .catch(() => {
        setError('Failed to fetch current config');
      })
      .finally(() => setFetching(false));
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      let parsedValue;
      try {
        parsedValue = JSON.parse(value);
      } catch {
        setError('Value must be valid JSON');
        setLoading(false);
        return;
      }
      await Api.put(`/driver-config/driver_config`, {
        key,
        value: JSON.stringify(parsedValue),
        description,
      });
      setSuccess(true);
    } catch (err) {
      setError('Failed to update config');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxWidth={600} mx="auto" mt={4}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>Update Config</Typography>
        {fetching ? (
          <Typography>Loading current config...</Typography>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              name="key"
              label="Title (key)"
              value={key}
              onChange={e => setKey(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
              required
              InputProps={{ readOnly: true }}
            />
            <TextField
              name="value"
              label="Value (JSON Object)"
              value={value}
              onChange={e => setValue(e.target.value)}
              fullWidth
              multiline
              minRows={10}
              variant="outlined"
              margin="normal"
              required
              placeholder='{"registration": {...}, "contact": {...}, ...}'
            />
            <TextField
              name="description"
              label="Description (optional)"
              value={description}
              onChange={e => setDescription(e.target.value)}
              fullWidth
              margin="normal"
              variant="outlined"
            />
            {error && <Typography color="error" mb={2}>{error}</Typography>}
            {success && <Typography color="success.main" mb={2}>Config updated successfully!</Typography>}
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
              {loading ? 'Saving...' : 'Update Config'}
            </Button>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default UpdateConfig;
